import { render, staticRenderFns } from "./edit-asset-dialog.vue?vue&type=template&id=6d52b696&scoped=true&"
import script from "./edit-asset-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-asset-dialog.vue?vue&type=script&lang=js&"
import style0 from "./edit-asset-dialog.vue?vue&type=style&index=0&id=6d52b696&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d52b696",
  null
  
)

export default component.exports